<template>
  <div @click.self="$emit('close')" class="frisbuy-popup-overlay">
    <div class="frisbuy-popup-alert-conditions">
      <div class="frisbuy-popup-alert-conditions__inner">
        <div class="frisbuy-lassie-popup-close-btn">
          <button @click="$emit('close')">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.35355 5.64645C6.15829 5.45118 5.84171 5.45118 5.64645 5.64645C5.45118 5.84171 5.45118 6.15829 5.64645 6.35355L11.2929 12L5.64645 17.6464C5.45118 17.8417 5.45118 18.1583 5.64645 18.3536C5.84171 18.5488 6.15829 18.5488 6.35355 18.3536L12 12.7071L17.6464 18.3536C17.8417 18.5488 18.1583 18.5488 18.3536 18.3536C18.5488 18.1583 18.5488 17.8417 18.3536 17.6464L12.7071 12L18.3536 6.35355C18.5488 6.15829 18.5488 5.84171 18.3536 5.64645C18.1583 5.45118 17.8417 5.45118 17.6464 5.64645L12 11.2929L6.35355 5.64645Z"
                fill="#858F9A"
              />
            </svg>
          </button>
        </div>

        <div class="frisbuy-popup-alert-conditions__text">
          Чтобы проголосовать, необходимо подписаться на email рассылку.
        </div>

        <button
          class="frisbuy-popup-alert-conditions__button-confirm"
          @click="$emit('confirm')"
        >
          Подписаться
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}

.frisbuy-popup-alert-conditions {
  display: block;
  position: absolute;

  background-color: #fff;
  border-radius: 10px;

  padding: 30px;

  max-width: 648px;
  min-height: 230px;
  gap: 51px;

  &,
  & * {
    font-family: Rubik, sans-serif;
  }

  &__inner {
    display: flex;
    flex-direction: column;
    justify-content: center;

    max-width: 588px;
    min-height: 170px;

    .frisbuy-lassie-popup-close-btn {
      display: flex;
    }
  }

  .frisbuy-lassie-popup-close-btn {
    height: 24px;

    margin: 0;
  }

  &__text {
    height: fit-content;

    margin-top: 28px;
    padding: 15px 16px;
  }

  &__button-confirm {
    display: inline-block;

    width: 150px;
    height: 40px;

    color: #fff;
    font-weight: 500;
    font-size: 12px;
    line-height: 24px;
    text-align: center;

    background: #42affe;
    border: none;
    border-radius: 10px;

    cursor: pointer;

    margin-top: 28px;
    // padding: 14px 49px;
  }
}
</style>

<script>
export default {
  emits: ["close", "confirm"],

  data() {
    return {};
  },
};
</script>
